// extracted by mini-css-extract-plugin
export default {"hintContainer":"hint-module__hintContainer____XeLa","image":"hint-module__image___t_gHe","textContainer":"hint-module__textContainer___Me15y","link":"hint-module__link___vYVnQ"};